
import CommonHeaderMobile from "../../components/common/common-header-mobile.vue";
import ChannelManager from "../../components/settings/channel-manager.vue";
import { ALL_CHANNELS } from "@/constants/Channels.js";

export default {
  components: { CommonHeaderMobile, ChannelManager },
  data() {
    return {
      addModifyDialog: true,
      selectedChannel: {},
      selectedChannelCategory: "unpaired"
    };
  },
  created() {
    this.selectedChannel = ALL_CHANNELS;
  },
  methods: {
    handleDialogClick() {
      this.addModifyDialog = true;
    },
    handlePairChannel(channel) {
      this.selectedChannel = channel;
    }
  }
};
